import { Component } from '@angular/core';
import { TileItem } from '../../models/tileItem';
import { TILES } from '../../constants/reference.constants';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationHttpService } from '../../../authentication/services/authentication-http.service';
import { LogService } from '../../../core/logger/services/log.service';
import { LayoutService } from '../../../layout/state/layout.service';
import { LayoutQuery } from '../../../layout/state/layout.query';
import { LayoutHttpService } from '../../../layout/services/layout-http.service';
import { UserService } from '../../../user/services/user.service';
import { ReferenceService } from '../../services/reference.service';
import { AuthenticationService } from '../../../authentication/state/authentication.service';
import { filter, forkJoin, take } from 'rxjs';

@Component({
  selector: 'app-reference-category',
  templateUrl: './reference-category.component.html',
  styleUrl: './reference-category.component.scss'
})
export class ReferenceCategoryComponent {
  managementTiles: TileItem[] = [];
  operationsTiles: TileItem[] = [];
  managementCount = 0;
  operationsCount = 0;
  orgId!: number;
  recipientGroups = {
    submittedToReview: [] as any[]
  };
  logedInUserName!: string;

  constructor(
    private router: Router,
    public layoutService: LayoutService,
    public layoutQuery: LayoutQuery,
    public referenceService: ReferenceService,
    private authenticationService: AuthenticationService
  ) { }

  ngOnInit(): void {
    this.orgId = Number(localStorage.getItem('SelectedOrgId'));

    const saved = sessionStorage.getItem("logedInUserName");
    if (saved) {
      this.logedInUserName = saved;
      this.afterUserLoaded();
      return;
    }

    this.authenticationService.authenticationQuery.select(s => s.userInfo)
      .pipe(
        filter(u => !!u),
        take(1)
      )
      .subscribe(u => {
        const name = u?.given_name || "";
        this.logedInUserName = name;

        sessionStorage.setItem("logedInUserName", name);

        this.afterUserLoaded();
      });
  }

  private afterUserLoaded() {
    if (!this.logedInUserName) return;  

    this.loadDocumentCounts();
  }

  loadDocumentCounts() {
    if (!this.orgId) return;

    this.fetchCategoryCount("QHSE - Management", (count: number) => {
      this.managementCount = count;
    });

    this.fetchCategoryCount("QHSE - Operations", (count: number) => {
      this.operationsCount = count;
    });
  }


  selectOrg(category: string) {
    localStorage.setItem('selectedCategory', category);
    this.router.navigate(['/reference/tiles'], {
      queryParams: { category }
    });
  }

  fetchCategoryCount(category: string, callback: Function) {
    this.referenceService
      .getDocumentsCountByCategory(this.orgId)
      .subscribe(
        (res: any) => {
          if (!Array.isArray(res)) {
            callback(0);
            return;
          }
          const filtered = res.filter(item =>
            item.stateName === "SubmittedToReview" &&
            item.recipientID === this.logedInUserName
          );
          const tilesWithCounts = this.mergeCountsWithTiles(filtered);

          const totalCount = tilesWithCounts
            .filter((tile: any) => tile.category === category)
            .reduce((sum: any, t: any) => sum + (t.documentCount || 0), 0);

          callback(totalCount);
        },
        (err: any) => console.error("Error fetching category docs:", err)
      );
  }

  mergeCountsWithTiles(apiCounts: any[]) {
    return TILES.map(tile => {
      const match = apiCounts.find(c => c.tileId === tile.id);
      return {
        ...tile,
        documentCount: match ? match.documentCount : 0
      };
    });
  }
}
